import { ServiceTestButton } from "src/config/types";
import { Button, Image } from "react-bootstrap";
import { handlers } from "../handlers";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NdtInput, NdtOutput } from "@npd-ng/network-diagnostic-tool";
import Spinner from "../../img/spinner.gif";
import { Interweave } from "interweave";
import warning from "../../img/warning.svg";
import green_check from "../../img/green_check.svg";

import { ModalWrapper } from "./ModalWrapper";

interface Props {
  data: ServiceTestButton;
  inputJson: NdtInput;
}

export type ApiStatus =
  | "notStarted"
  | "Loading"
  | "Finished"
  | "Error"
  | "NetworkError";

export interface TestStatus {
  status: ApiStatus;
  response?: NdtOutput;
}

export const ServiceTest = (props: Props) => {
  const { data, inputJson } = props;
  const { t } = useTranslation();

  const containerStyles: React.CSSProperties = {
    minWidth: "306px",
    // textAlign: "center"
  };

  const containerContentStyles: React.CSSProperties = {
    minHeight: "103px",
    display: "block",
    width: "100%",
    marginBottom: "28px",
  };
  const safelistContainerContentStyles: React.CSSProperties = {
    
    display: "block",
    width: "100%",
    marginBottom: "28px",
  };

  const imageStyles: React.CSSProperties = {
    width: "30px",
    paddingRight: "10px",
    display: "inline",
  };

  const [apiStatus, setApiStatus] = useState<TestStatus>({
    status: "notStarted",
  });
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
    console.log("triggered");
  };

  const renderSpeed = (num: number): string => {
    const mega = num / 1000;
    if (mega < 1) {
      return `${Math.floor(mega * 100) / 100} Mbps`;
    }
    return `${Math.floor(mega)} Mbps`;
  };

  const handleOpenModal = () => {
    setOpenModal(true);
    if (data.function) {
      const execFun = handlers[data.function];
      if (execFun) execFun(setApiStatus, inputJson);
    }
  };

  //
  const renderTest = () => {
    switch (apiStatus.status) {
      case "Finished":
        return (
          <div
            style={{
              ...containerStyles,
              textAlign: "left",
            }}
          >
            <p
              style={{
                color: "#333333",
                fontSize: "18px",
                fontWeight: "700",
              }}
            >
              {data.results.title}
            </p>
            <p>{data.results.message}</p>
            <div>{renderResults()}</div>
            <div
              onClick={() => {
                if (data.function) {
                  const execFun = handlers[data.function];
                  if (execFun) execFun(setApiStatus, inputJson);
                }
              }}
              style={{
                fontSize: "16px",
                color: "#1159a7",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {data.runAgainText}
            </div>
          </div>
        );
      case "Loading":
        return (
          <div style={containerStyles}>
            <p
              style={{
                color: "#333333",
                fontSize: "18px",
              }}
            >
              {data.loading.message1}
            </p>
            <p>{data.loading.message2}</p>
            <div style={containerContentStyles}>
              <Image
                src={Spinner}
                title={t("loading")}
                style={{
                  maxWidth: "75%",
                }}
              />
            </div>
          </div>
        );
      case "Error":
        return (
          <div
            style={{
              ...containerStyles,
              textAlign: "left",
            }}
          >
            <p
              style={{
                color: "#333333",
                fontSize: "18px",
                fontWeight: "700",
              }}
            >
              {data.results.title}
            </p>
            <div className="safelist-result-header">
              <div>
                <p>
                  <Interweave content={data.error.general.message} />
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                if (data.function) {
                  const execFun = handlers[data.function];
                  if (execFun) execFun(setApiStatus, inputJson);
                }
              }}
              style={{
                fontSize: "16px",
                color: "#1159a7",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {data.runAgainText}
            </div>
          </div>
        );
      case "NetworkError":
        return (
          <div
            style={{
              ...containerStyles,
              textAlign: "left",
            }}
          >
            <p
              style={{
                color: "#333333",
                fontSize: "18px",
                fontWeight: "700",
              }}
            >
              {data.results.title}
            </p>
            <div className="safelist-result-header">
              <div>
                <p>
                  <Interweave content={data.error.network.message} />
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                if (data.function) {
                  const execFun = handlers[data.function];
                  if (execFun) execFun(setApiStatus, inputJson);
                }
              }}
              style={{
                fontSize: "16px",
                color: "#1159a7",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {data.runAgainText}
            </div>
          </div>
        );
    }

    return <></>;
  };

  const renderResults = () => {
    if (data.function === "safeListCheck") {
      console.log("safelist results");
      return (
      <>
        <>{renderSafeListresults()}</>
        <div>{renderContentFilteringresults()}</div>
      </>)
    }

    if (data.function === "bandwidthCheck") {
      console.log("bandwidth results");
      return renderBandwidthResults();
    }
    return <p>No function</p>;
  };

  const renderSafeListresults = () => {
    if (apiStatus.response?.ndtResults.details?.safeList) {
      const safeListUrls =
        apiStatus.response?.ndtResults.details?.safeList.urls.filter(
          (url) =>
            url.statusCode === "7032" ||
            (url.statusCode === "7035" && url.url.indexOf("REQUIRED") > -1)
        );
      const safeListSuccess =
        apiStatus.response?.ndtResults.details?.safeList.status === "success";

      if (safeListSuccess) {
        return (
          <div style={safelistContainerContentStyles}>
            <div className="results">
              <div style={imageStyles}>
                <Image
                  src={green_check}
                  title={t("complete")}
                  style={{
                    width: "20px",
                  }}
                />
              </div>
              <div className="safelist-result-header">
                <div>
                  <p>
                    <Interweave content={data.results.result[0]} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div style={containerContentStyles}>
            <div className="results">
              <div style={imageStyles}>
                <Image
                  src={warning}
                  title={t("warning")}
                  style={{
                    width: "18px",
                  }}
                />
              </div>
              <div className="safelist-result-header">
                <div>
                  <p
                    style={{
                      color: "#333333",
                    }}
                  >
                    <Interweave content={data.failed.message1} />
                  </p>
                  {safeListUrls.map((url) => {
                    return (
                      <p
                        style={{
                          color: "#9b2c2c",
                          marginBottom: "2px",
                        }}
                      >
                        {url.url.split(" (REQUIRED)")[0]}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
  };
  const renderContentFilteringresults = () => {
    if (apiStatus.response?.ndtResults.details?.contentFiltering) {
      const contentFilteringSuccess =
        apiStatus.response?.ndtResults.details?.contentFiltering.status === "success";

      if (!contentFilteringSuccess) { 
        return (
          <div style={containerContentStyles}>
            <div className="results">
              <div style={imageStyles}>
                <Image
                  src={warning}
                  title={t("warning")}
                  style={{
                    width: "18px",
                  }}
                />
              </div>
              <div className="safelist-result-header">
                <div>
                  <p
                    style={{
                      color: "#333333",
                    }}
                  >
                    <Interweave content={data.failed.message2} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
  };

  const renderBandwidthResults = () => {
    if (apiStatus.response?.ndtResults.details?.speedTest) {
      const speedTest = apiStatus.response?.ndtResults.details?.speedTest;
      const dlFail = speedTest.failureReasons
        ? speedTest.failureReasons.find((item) => item.code === "7021")
        : false;
      const ulFail = speedTest.failureReasons
        ? speedTest.failureReasons.find((item) => item.code === "7022")
        : false;
      return (
        <div style={containerContentStyles}>
          {dlFail ? (
            <div
              className="results"
              style={{
                marginBottom: "12px",
              }}
            >
              <div style={imageStyles}>
                <Image
                  src={warning}
                  title={t("warning")}
                  style={{
                    width: "18px",
                  }}
                />
              </div>
              <div className="bandwidth-result-header">
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0",
                    }}
                  >
                    {speedTest.download && renderSpeed(speedTest.download)}
                  </p>
                </div>
                <div>
                  <Interweave content={data.results.result[1]} />
                </div>
              </div>
              <div>
                <p
                  style={{
                    color: "#9b2c2c",
                    fontSize: "16px",
                    paddingLeft: "30px",
                  }}
                >
                  <Interweave content={data.failed.message2} />
                </p>
              </div>
            </div>
          ) : (
            <div
              className="results"
              style={{
                marginBottom: "12px",
              }}
            >
              <div style={imageStyles}>
                <Image
                  src={green_check}
                  title={t("complete")}
                  style={{
                    width: "20px",
                  }}
                />
              </div>
              <div className="bandwidth-result-header">
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0",
                    }}
                  >
                    {speedTest.download && renderSpeed(speedTest.download)}
                  </p>
                </div>
                <div>
                  <Interweave content={data.results.result[1]} />
                </div>
              </div>
            </div>
          )}
          {ulFail ? (
            <div className="results">
              <div style={imageStyles}>
                <Image
                  src={warning}
                  title={t("warning")}
                  style={{
                    width: "18px",
                  }}
                />
              </div>
              <div className="bandwidth-result-header">
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0",
                    }}
                  >
                    {speedTest.upload && renderSpeed(speedTest.upload)}
                  </p>
                </div>
                <div>
                  <Interweave content={data.results.result[0]} />
                </div>
              </div>
              <div>
                <p
                  style={{
                    color: "#9b2c2c",
                    fontSize: "16px",
                    paddingLeft: "30px",
                    marginBottom: "0",
                  }}
                >
                  <Interweave content={data.failed.message1} />
                </p>
              </div>
            </div>
          ) : (
            <div className="results">
              <div style={imageStyles}>
                <Image
                  src={green_check}
                  title={t("complete")}
                  style={{
                    width: "20px",
                  }}
                />
              </div>
              <div className="bandwidth-result-header">
                <div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "0",
                    }}
                  >
                    {speedTest.upload && renderSpeed(speedTest.upload)}
                  </p>
                </div>
                <div>
                  <Interweave content={data.results.result[0]} />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div style={containerContentStyles}>
          <div className="results">
            <div style={imageStyles}>
              <Image
                src={warning}
                title={t("warning")}
                style={{
                  width: "18px",
                }}
              />
            </div>
            <div className="bandwidth-result-header">
              <div>
                <p
                  style={{
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "700",
                  }}
                >
                  <Interweave content={data.error.network.message} />
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div style={containerStyles}>
      <ModalWrapper open={openModal} handleClose={handleCloseModal}>
        <>
          {renderTest()}
          <Button
            variant="outline-secondary"
            style={{
              backgroundColor: "#1159a7",
              color: "white",
              cursor: "pointer !important",
              marginTop: "20px",
              ...data.styles,
            }}
            onClick={handleCloseModal}
          >
            {data.closeBtn}
          </Button>
        </>
      </ModalWrapper>
      <Button
        variant="outline-secondary"
        style={{
          backgroundColor: "#1159a7",
          color: "white",
          cursor: "pointer !important",
          margin: "20px",
          ...data.styles,
        }}
        onClick={handleOpenModal}
      >
        {data.text && t(data.text)}
      </Button>
    </div>
  );
};
